module.exports = {"130703001":"新华街街道","130703002":"大境门街道","130703003":"明德北街街道","130703004":"明德南街街道","130703005":"堡子里街道","130703006":"南营坊街道","130703007":"工人新村街道","130703100":"东窑子镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130703.json
// module id = 266
// module chunks = 0